import { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import { ScrollableContainer, ScrollableContainerProps } from '@hh.ru/magritte-ui-scrollable-container';

import styles from './checkable-card.less';

export const CheckableCardScrollableContainer: FC<PropsWithChildren<ScrollableContainerProps>> = ({
    disableButtons,
    children,
    ...containerProps
}) => {
    return (
        <ScrollableContainer
            data-qa="checkable-card-scrollable-container"
            {...containerProps}
            disableButtons={disableButtons}
        >
            <div className={classnames(styles.scrollContainer, { [styles.scrollContainerMobile]: !!disableButtons })}>
                {children}
            </div>
        </ScrollableContainer>
    );
};
